import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FilePlus2, LayoutDashboard, Settings } from 'lucide-react';
import { getReviewsSent, getReviewsReceived } from '../services/api';
import ReviewsSentPanel from './ReviewsSentPanel';
import ReviewsReceivedPanel from './ReviewsReceivedPanel';

function HomePage() {
  const [sentReviews, setSentReviews] = useState([]);
  const [receivedReviews, setReceivedReviews] = useState([]);
  const [loadingSent, setLoadingSent] = useState(true);
  const [loadingReceived, setLoadingReceived] = useState(true);

  useEffect(() => {
    getReviewsSent()
      .then((data) => setSentReviews(data?.reviews ?? []))
      .catch(() => setSentReviews([]))
      .finally(() => setLoadingSent(false));

    getReviewsReceived()
      .then((data) => setReceivedReviews(data?.reviews ?? []))
      .catch(() => setReceivedReviews([]))
      .finally(() => setLoadingReceived(false));
  }, []);

  return (
    <div className="home-page">
      <div className="home-welcome">
        <h2>Welcome to TestGenius</h2>
        <p>
          A collaborative platform for creating, reviewing, and exporting test cases.
          Use AI-powered generation with Amazon Bedrock or upload your own CSV files,
          then route them through a peer review workflow before exporting to TestRail.
        </p>
        <div className="home-nav-cards">
          <Link to="/upload" className="home-nav-card">
            <span className="home-nav-icon"><FilePlus2 size={28} /></span>
            <span className="home-nav-label">New Review Request</span>
            <span className="home-nav-desc">Upload a CSV or use Hawkeye Test Case Generator, then assign reviewers</span>
          </Link>
          <Link to="/files" className="home-nav-card">
            <span className="home-nav-icon"><LayoutDashboard size={28} /></span>
            <span className="home-nav-label">Review Dashboard</span>
            <span className="home-nav-desc">Browse all submitted test case files and their approval status</span>
          </Link>
          <Link to="/settings" className="home-nav-card">
            <span className="home-nav-icon"><Settings size={28} /></span>
            <span className="home-nav-label">Settings</span>
            <span className="home-nav-desc">Configure your TestRail connection and other preferences</span>
          </Link>
        </div>
      </div>

      <div className="home-dashboard-section">
        <ReviewsSentPanel
          reviews={sentReviews}
          loading={loadingSent}
          emptyMessage="You haven't sent any reviews yet."
        />
        <ReviewsReceivedPanel
          reviews={receivedReviews}
          loading={loadingReceived}
          emptyMessage="You haven't received any review requests yet."
        />
      </div>
    </div>
  );
}

export default HomePage;
